import * as THREE from 'three';
import { FlyControls } from 'three/examples/jsm/controls/FlyControls.js';
import { StateManager } from "./statemanager";
import { State } from "./state";
import { MapManager } from "../maps/mapmanager";
import { DataManager, GDM } from "../helpers/datamanager";
import { AnimationData } from '../loaders/zmo';
import { Mesh } from '../loaders/zms';
import { TextureManager } from '../datamanagers/texturemanager';
import { ShaderManager } from '../datamanagers/shadermanager';
import { CameraAnimator } from '../animators/cameraanimator';
import { CharPawn } from '../pawns/charpawn';
import { SkeletonAnimator } from '../animators/skeletonanimator';
import { Int64 } from '../types/int64';
import { InventoryData } from '../gamedata/inventorydata';

export class TestState extends State {
    DM: any;
    world: any;
    activeCamAnim: any;
    controls: any;

    constructor() {
        super();
        this.DM = new DataManager();
        this.world = null;
    }

    async prepare(): Promise<void> {
        this.DM.register(
            "canim_intro",
            AnimationData,
            "3DDATA/TITLE/CAMERA01_INTRO01.ZMO"
        ); // TITLEIROSE
        this.DM.register(
            "canim_inselect",
            AnimationData,
            "3DDATA/TITLE/CAMERA01_INSELECT01.ZMO"
        );
        this.DM.register(
            "canim_ingame",
            AnimationData,
            "3DDATA/TITLE/CAMERA01_INGAME01.ZMO"
        );
        this.DM.register(
            "canim_create",
            AnimationData,
            "3DDATA/TITLE/CAMERA01_CREATE01.ZMO"
        );
        this.DM.register(
            "canim_outcreate",
            AnimationData,
            "3DDATA/TITLE/CAMERA01_OUTCREATE01.ZMO"
        );
        await new Promise<void>((resolve) => {
            this.DM.get("canim_intro", () => {
                resolve();
                // Continue by preloading the rest for now.
                this.DM.get("canim_inselect");
                this.DM.get("canim_ingame");
                this.DM.get("canim_create");
                this.DM.get("canim_outcreate");
            });
        });
        this.activeCamAnim = null;
    }

    playCamAnim(name: any, loopCount: any) {
        this.DM.get(name, (zmoData: any) => {
            if (this.activeCamAnim) {
                this.activeCamAnim.stop();
                this.activeCamAnim = null;
            }
            this.activeCamAnim = new CameraAnimator(
                camera,
                zmoData,
                new THREE.Vector3(5200, 5200, 0)
            );
            this.activeCamAnim.play(loopCount);
        });
    }

    goInSelect() {
        this.playCamAnim("canim_inselect", 1);
    }

    goInGame() {
        this.playCamAnim("canim_ingame", 1);
    }

    enter() {
        debugGui.addButton("Go In Select", this.goInSelect.bind(this));
        debugGui.addButton("Go In Game", this.goInGame.bind(this));
        const wm = new MapManager();
        wm.rootObj.position.set(5200, 5200, 0);
        wm.setMap(2, () => {
            console.log("Map Ready");
        });
        this.world = wm;
        scene.add(wm.rootObj);
        //this.playCamAnim('canim_intro');
        let controls = new FlyControls(camera, renderer.domElement);
        controls.movementSpeed = 100;
        controls.rollSpeed = Math.PI / 24;
        controls.dragToLook = false; // Any mouse button to rotate
        this.controls = controls;
        camera.position.x = 5200;
        camera.position.y = 5450;
        camera.position.z = 140;
        /*
      let charObj = new NpcCharacter();
      charObj.setModel(1);
      */
        const charObj = new CharPawn();
        charObj.setGender(0, function () {
            charObj.setModelPart(3, 1, 0);
            charObj.setModelPart(4, 1, 0);
            charObj.setModelPart(5, 1, 0);
            charObj.setModelPart(7, 202, 0);
            charObj.setModelPart(8, 2, 0);
            const animPath = "3DData/Motion/Avatar/EMPTY_STOP1_M1.ZMO";
            AnimationData.load(animPath, function (zmoData: any) {
                const anim = new SkeletonAnimator(charObj.skel, zmoData);
                anim.play();
            });
        });
        charObj.rootObj.position.set(5205, 5205, 1);
        charObj.rootObj.rotateOnAxis(new THREE.Vector3(0, 0, 1), Math.PI);
        charObj.rootObj.scale.set(1.2, 1.2, 1.2);
        scene.add(charObj.rootObj);
        Mesh.load("3DDATA/JUNON/SKY/DAY01.ZMS", function (geom: any) {
            const texd = TextureManager.load("3DDATA/JUNON/SKY/DAY01.DDS");
            const texn = TextureManager.load("3DDATA/JUNON/SKY/NIGHT01.DDS");
            const mat = ShaderManager.get("skydome").clone();
            mat.uniforms = {
                texture1: { type: "t", value: texd },
                texture2: { type: "t", value: texn },
                blendRatio: { type: "f", value: 0.5 },
            };
            skyObject = new THREE.Mesh(geom, mat);
            scene.add(skyObject);
        });
        const invPak = {
            result: 1,
            money: { lo: 200, hi: 0 },
            items: [
                {
                    itemType: 2,
                    itemNo: 222,
                    charDbId: 3435973836,
                    color: 1,
                    itemKey: { lo: 9532290, hi: 0 },
                    isCrafted: 0,
                    gemOption1: 0,
                    gemOption2: 0,
                    gemOption3: 0,
                    durability: 32,
                    itemLife: 1000,
                    socketCount: 0,
                    isAppraised: 0,
                    refineGrade: 0,
                    quantity: 1,
                    location: 1,
                    slotNo: 0,
                    timeRemaining: 0,
                    moveLimits: 0,
                    bindOnAcquire: 0,
                    bindOnEquipUse: 0,
                    money: 0,
                },
                {
                    itemType: 8,
                    itemNo: 1,
                    charDbId: 3435973836,
                    color: 1,
                    itemKey: { lo: 9532291, hi: 0 },
                    isCrafted: 0,
                    gemOption1: 0,
                    gemOption2: 0,
                    gemOption3: 0,
                    durability: 19,
                    itemLife: 997,
                    socketCount: 0,
                    isAppraised: 0,
                    refineGrade: 0,
                    quantity: 1,
                    location: 2,
                    slotNo: 7,
                    timeRemaining: 0,
                    moveLimits: 0,
                    bindOnAcquire: 0,
                    bindOnEquipUse: 0,
                    money: 0,
                },
                {
                    itemType: 5,
                    itemNo: 29,
                    charDbId: 3435973836,
                    color: 1,
                    itemKey: { lo: 9532292, hi: 0 },
                    isCrafted: 0,
                    gemOption1: 0,
                    gemOption2: 0,
                    gemOption3: 0,
                    durability: 7,
                    itemLife: 998,
                    socketCount: 0,
                    isAppraised: 0,
                    refineGrade: 0,
                    quantity: 1,
                    location: 2,
                    slotNo: 6,
                    timeRemaining: 0,
                    moveLimits: 0,
                    bindOnAcquire: 0,
                    bindOnEquipUse: 0,
                    money: 0,
                },
                {
                    itemType: 3,
                    itemNo: 29,
                    charDbId: 3435973836,
                    color: 1,
                    itemKey: { lo: 9532293, hi: 0 },
                    isCrafted: 0,
                    gemOption1: 0,
                    gemOption2: 0,
                    gemOption3: 0,
                    durability: 12,
                    itemLife: 999,
                    socketCount: 0,
                    isAppraised: 0,
                    refineGrade: 0,
                    quantity: 1,
                    location: 2,
                    slotNo: 3,
                    timeRemaining: 0,
                    moveLimits: 0,
                    bindOnAcquire: 0,
                    bindOnEquipUse: 0,
                    money: 0,
                },
            ],
        };
        function checkForInt64(val: any) {
            if (val instanceof Object) {
                for (let i in val) {
                    if (Array.isArray(val[i])) {
                        for (let j = 0; j < val[i].length; ++j) {
                            checkForInt64(val[i][j]);
                        }
                    } else if (val[i] instanceof Object) {
                        if (
                            val[i].lo !== undefined &&
                            val[i].hi !== undefined
                        ) {
                            val[i] = new Int64(val[i].lo, val[i].hi);
                        } else {
                            checkForInt64(val[i]);
                        }
                    }
                }
            }
        }
        checkForInt64(invPak);
        const dt = new Date();
        GDM.get("item_data", function () {
            console.log(new Date().getTime() - dt.getTime());
            const invData = InventoryData.fromPacketData(invPak);
            const invDialog = ui.inventoryDialog(invData);
            invDialog.show();
        });
    }

    leave() {}

    update(delta: any) {
        if (this.controls) {
            this.controls.update(delta);
        }
        if (this.world && this.world.isLoaded) {
            this.world.setViewerInfo(camera.position);
            this.world.update(delta);
        }
    }
}

/**
 * @constructor
 */

StateManager.register("test", TestState);
